import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { faqs } from '../../../environments/faqs';

@Component({
    imports: [CommonModule],
    selector: 'faq-services',
    styleUrls: ['./faq-services.scss'],
    templateUrl: './faq-services.html',
    standalone: true
})
export class FaqServicesComponent implements OnInit {
  appURL: string = environment.appURL;
  @Input() random: number = 0;
  @Input() service: string = '';
  faqs: any;
  selectedFaq: any;

  constructor() { }

  ngOnInit() {
    this.faqs = faqs[this.service];
    if(this.random) {
      const shuffled = this.faqs.sort(() => 0.5 - Math.random());
      this.faqs = shuffled.slice(0, this.random);
    }
  }

  onClickedFaq(value :any) {
    if (this.selectedFaq == value) {
      this.selectedFaq = '';
    } else {
      this.selectedFaq = value;
    }
  }
}
